import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, useTheme } from '@mui/material';
import { floatCenter } from '../../cosmetics/styleHelpers';
import { v4 } from 'uuid';
import { getFromRange } from '@iotv/datamodel-core';
var BatteryStatus;
(function (BatteryStatus) {
    BatteryStatus[BatteryStatus["GOOD"] = 0] = "GOOD";
    BatteryStatus[BatteryStatus["MID"] = 1] = "MID";
    BatteryStatus[BatteryStatus["BAD"] = 2] = "BAD";
    BatteryStatus[BatteryStatus["UNKNOWN"] = 3] = "UNKNOWN";
})(BatteryStatus || (BatteryStatus = {}));
const BatteryStatusRanges = [
    { low: null, high: 10, value: BatteryStatus.BAD },
    { low: 10, high: 50, value: BatteryStatus.MID },
    { low: 50, high: null, value: BatteryStatus.GOOD },
];
export const BatteryPercentIcon = (props) => {
    const { hideText, batteryStatusColors: batteryStatusColorsIn, percentage } = props;
    const id = v4();
    const theme = useTheme();
    const batteryStatusColors = batteryStatusColorsIn ?? {
        [BatteryStatus.GOOD]: { fg: theme.palette.success.light, bg: 'maroon' }, // used to be '#82c640'
        [BatteryStatus.MID]: { fg: theme.palette.warning.light, bg: '' }, // used to be '#ffeb3b'
        [BatteryStatus.BAD]: { fg: theme.palette.error.light, bg: '' }, // used to be 'red'
        [BatteryStatus.UNKNOWN]: { fg: 'white', bg: '' }, // used to be 'red'
    };
    const batteryStatus = percentage === null ? BatteryStatus.UNKNOWN : getFromRange(BatteryStatusRanges, percentage);
    const clipStyle = {
        width: '100%',
        height: '100%',
        clipPath: props.variant == 'horizontal' ? `url(#battery-path-rotated-${id})` : `url(#battery-path-${id})`,
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'hidden',
        //transform: props.variant == "horizontal" ? "rotate(90deg)" : ""
    };
    const percentageNum = props.percentage ?? 0;
    const bgStyle = props.percentage
        ? {
            width: '100%',
            height: '100%',
            backgroundColor: batteryStatusColors[batteryStatus].bg,
            opacity: 0.5,
        }
        : {
            width: '100%',
            height: '100%',
            backgroundColor: 'gray',
            opacity: 0.5,
        };
    const fgStyle = {
        width: '100%',
        height: '100%',
        backgroundColor: batteryStatusColors[batteryStatus].fg,
        position: 'absolute',
        top: props.variant == 'horizontal' ? 0 : `${100 - percentageNum}%`,
        right: props.variant == 'horizontal' ? `${100 - percentageNum}%` : 0,
    };
    const textStyle = {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        //fontSize: "5pt",
        //color: props.percentage > 30 ? "#82c640" : ( props.percentage > 10 ? "#ffeb3b" : "red" ),
        ...floatCenter,
    };
    return (_jsxs("div", { style: { width: '100%', height: '100%', position: 'relative' }, children: [_jsx("svg", { width: 0, height: 0, children: _jsxs("defs", { children: [_jsx("clipPath", { id: `battery-path-${id}`, clipPathUnits: "objectBoundingBox", children: _jsx("path", { d: "M 0.86700005,0.10000002 H 0.7000001 V 0 H 0.2999999 v 0.10000002 h -0.167 c -0.073,0 -0.133,0.03 -0.133,0.0665 V 0.933 c 0,0.037 0.06,0.067 0.133,0.067 h 0.73300015 c 0.074,0 0.13400005,-0.03 0.13400005,-0.0665 V 0.16650002 c 0,-0.0365 -0.0600001,-0.0665 -0.13300005,-0.0665 z" }) }), _jsx("clipPath", { id: `battery-path-rotated-${id}`, clipPathUnits: "objectBoundingBox", children: _jsx("path", { d: "M 0.89999998,0.86700005 V 0.7000001 H 1 V 0.2999999 H 0.89999998 v -0.167 c 0,-0.073 -0.03,-0.133 -0.0665,-0.133 H 0.067 c -0.037,0 -0.067,0.06 -0.067,0.133 v 0.73300015 c 0,0.074 0.03,0.13400005 0.0665,0.13400005 h 0.76699998 c 0.0365,0 0.0665,-0.0600001 0.0665,-0.13300005 z" }) })] }) }), _jsxs("div", { style: clipStyle, children: [_jsx("div", { id: "battery-bg", style: bgStyle }), _jsx("div", { id: "battery-fg", style: fgStyle }), hideText !== true && (_jsxs(Typography, { id: "battery-text", style: textStyle, children: [props.percentage === null ? '?' : `${Math.round(props.percentage)}`, props.percentage !== null ? _jsx("span", { style: { fontSize: '0.8em' }, children: "%" }) : _jsx(_Fragment, {})] }))] })] }));
};
